import { BoundedContent, Box, Column, GridContainer, H2, H3, Row } from '@vp/swan';
import { __ } from '@99designs/i18n';
import { FeaturedProductsType } from '../../graph/getProductsByKey';
import { ProductTile } from './ProductTile';
import type { DesignServicesProductNames } from '../../types';

interface FeaturedProductsProps {
    products: FeaturedProductsType;
}

export const FeaturedProductsId = 'featured-products';

// When making changes here, also update the getProductsByKey query on the DS landing page
// FIXME -  replace both this and the query variables with a product group when CARE products are imported into the catalog
const FEATURED_PRODUCTS: DesignServicesProductNames[] = [
    'business-card-design',
    'logo-essential',
    'flyer-design',
    'brand-identity-pack',
];

export function FeaturedProducts({ products }: FeaturedProductsProps) {
    return (
        <Box marginTop="between-sections" id={FeaturedProductsId} data-testid="featured-products">
            <BoundedContent>
                <H2 textAlign={{ md: 'center', sm: 'left' }} fontSkin="title-section">
                    {__('Choose what you need designed', {
                        _context: 'section title for product category section on the hub page',
                    })}
                </H2>
                <H3
                    textAlign={{ md: 'center', sm: 'left' }}
                    fontSkin="body-standard"
                    fontSize="standard"
                    fontWeight="normal"
                    mb="between-subsections"
                >
                    {__('Browse custom design options to build your unique brand.')}
                </H3>
                <GridContainer>
                    <Row>
                        {FEATURED_PRODUCTS.map((p, i) => (
                            <Column key={p} span={3} spanXs={6}>
                                <ProductTile productKey={p} displayIndex={i + 1} {...products[p]} />
                            </Column>
                        ))}
                    </Row>
                </GridContainer>
            </BoundedContent>
        </Box>
    );
}
